<template>
  <div class="card mb-3">
    <div class="card-body">
      <h4>{{ diary.title }}</h4>
      <p>{{ diary.description }}</p>
      <p class="text-muted small no-margin-btm">
        Due - {{ formatDate(diary.date_time) }} &bullet; Assigned To -
        {{
          diary.user?.full_name ||
            diary?.incident?.handler?.full_name ||
            'Not Assigned'
        }}
        <template v-if="diary.completed_at">
          &bullet; Completed - {{ formatDate(diary.completed_at) }} &bullet;
          Completed by - {{ diary.completed_by?.full_name }}
        </template>
      </p>

      <button
        type="button"
        class="btn btn-primary btn-sm half-gutter-top"
        @click="emitComplete()"
        v-if="!diary.completed_at && !readonly"
      >
        Mark As Complete
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    diary: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    formatDate(value) {
      return window.DateManager.format(value);
    },

    emitComplete() {
      this.$emit('complete');
    }
  }
};
</script>
